export default __webpack_public_path__ + "static/media/016-Poodle.bb4dc11c.svg";